// src/cms/video-upload/view/video-delete-dialog.jsx
import React from "react";
import axios from "axios";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import CircularProgress from "@material-ui/core/CircularProgress";

class VideoDeleteDialog extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      deleting: false,
      error: "",
    };
    this.handleDelete = this.handleDelete.bind(this);
  }

  // --- helpers ---
  getAccessToken() {
    try {
      return localStorage.getItem("accessToken") || "";
    } catch (e) {
      return "";
    }
  }

  getDomainId() {
    var login = this.props && this.props.login ? this.props.login : null;
    if (!login || !login.user) return null;
    var ad = login.user.activeDomain || null;
    if (!ad) return null;
    return ad.domain_id || ad.domainId || ad.id || null;
  }

  getApiBase() {
    var base =
      typeof process !== "undefined" &&
      process.env &&
      process.env.REACT_APP_BLUE_SERVER
        ? process.env.REACT_APP_BLUE_SERVER
        : "";
    if (base && base.charAt(base.length - 1) === "/") base = base.slice(0, -1);
    return base;
  }
  // ---

  handleDelete() {
    var domainId = this.getDomainId();
    if (!domainId) domainId = 9704;

    var apiBase = this.getApiBase() || "http://localhost:4000";
    var accessToken = this.getAccessToken();
    var videoId = this.props.video && this.props.video.id;

    if (!videoId) {
      this.setState({ error: "Video ID is missing." });
      return;
    }

    var url =
      apiBase + "/article/" + String(domainId) + "/video/" + String(videoId);

    var self = this;
    this.setState({ deleting: true, error: "" });

    axios
      .delete(url, {
        headers: { Authorization: accessToken || "" },
        timeout: 30000,
      })
      .then(function () {
        self.setState({ deleting: false });
        if (self.props.onDeleted) {
          self.props.onDeleted();
        }
      })
      .catch(function (err) {
        console.error("Failed to delete video:", err);
        var msg = "Delete failed.";
        try {
          if (err && err.response && err.response.data) {
            msg +=
              " " +
              (typeof err.response.data === "string"
                ? err.response.data
                : err.response.data.message || JSON.stringify(err.response.data));
          }
        } catch (e2) {}
        self.setState({ deleting: false, error: msg });
      });
  }

  render() {
    var s = this.state;
    var props = this.props;
    var video = props.video || {};

    return (
      <Dialog
        open={props.open}
        onClose={props.onClose}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle style={{ paddingRight: 48 }}>
          Delete Video
          <IconButton
            onClick={props.onClose}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div style={{ fontSize: 14, color: "#1f2328", lineHeight: 1.6 }}>
            <p style={{ margin: "0 0 12px 0" }}>
              Are you sure you want to delete this video?
            </p>
            <div style={videoInfoStyle}>
              <strong>{video.title || "(untitled)"}</strong>
              {video.slug ? (
                <div style={{ fontSize: 12, color: "#57606a", marginTop: 4 }}>
                  /{video.slug}
                </div>
              ) : null}
            </div>
            <p style={{ margin: "12px 0 0 0", fontSize: 13, color: "#57606a" }}>
              The video will be soft-deleted and hidden from public view. It can
              be recovered later if needed.
            </p>
          </div>
          {s.error ? <div style={errorStyle}>{s.error}</div> : null}
        </DialogContent>
        <DialogActions style={{ padding: "12px 24px" }}>
          <Button onClick={props.onClose} disabled={s.deleting}>
            Cancel
          </Button>
          <Button
            onClick={this.handleDelete}
            variant="contained"
            disabled={s.deleting}
            style={{
              background: s.deleting ? "#ccc" : "#d32f2f",
              color: "white",
            }}
          >
            {s.deleting ? (
              <CircularProgress size={20} style={{ color: "white" }} />
            ) : (
              "Delete"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default VideoDeleteDialog;

// --- inline styles ---
var videoInfoStyle = {
  padding: "10px 12px",
  background: "#f6f8fa",
  borderRadius: 8,
  border: "1px solid #e6e6e6",
};

var errorStyle = {
  color: "crimson",
  background: "#fff0f0",
  border: "1px solid #ffd6d6",
  padding: "8px 10px",
  borderRadius: 8,
  marginTop: 12,
};
